import React, { useEffect, useCallback } from 'react';

import { object, string } from 'yup';
import { useFormik } from 'formik';

import { locale } from 'src/config';
import TextInput from 'src/components/TextInput';
import { buildHelperText } from 'src/utils/components';
import { checkNumberTyping } from 'src/utils/standards';

interface NumberFieldProps {
  field: UCM.DynamicFieldType;
  value: { value: string } | undefined;
  onChange: (field: UCM.DynamicFieldType, value: { value: string }) => void;
  helperText?: string;
}

const checkParam = { locale, decimals: 2 };

export default function NumberField({
  field,
  value,
  onChange,
  helperText = '',
  ...others
}: NumberFieldProps) {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { value: value?.value || '' },
    validateOnChange: true,
    validationSchema: object().shape({
      value: string().nullable(),
    }),
    onSubmit: () => {},
  });

  const { values, errors, setFieldValue } = formik;

  useEffect(() => {
    if (formik.dirty) {
      onChange(field, values);
    }
  }, [values.value, field]);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const stringValue = event.target.value;

      if (checkNumberTyping(stringValue, checkParam)) {
        setFieldValue('value', stringValue);
      }
    },
    [],
  );

  return (
    <TextInput
      {...others}
      fullWidth
      label={field.label}
      value={values.value}
      onChange={(e) => handleChange(e)}
      helperText={
        errors.value || buildHelperText(field.description, helperText)
      }
      error={!!errors.value}
    />
  );
}
